import React, { useEffect, useState } from 'react'
import { Modal, Button, Card, Form, Spinner, Row, Col, Container } from 'react-bootstrap'

export default function UkiesAssets(props) {
    const { open, setOpen, onAssetSelect, token } = props
    const [assets, setAssets] = useState({ hits: [] })
    const [assetList, setAssetList] = useState([])
    const [preview, setPreview] = useState('')
    const [search, setSearch] = useState('')
    const [selected, setSelected] = useState({ id: 0 })
    const [loading, setLoading] = useState(false)
    const [uploadingAsset, setUploadingAsset] = useState(false)

    useEffect(() => {
        if (open) {
            if (assets.hits.length === 0) {
                getFiles()
            }
        }
    }, [open])

    useEffect(() => {
        setAssetList(assets.hits.filter((asset) => { return (['jpg', 'jpeg', 'png'].includes(asset.extension)) }) || [])
    }, [assets])

    const getFiles = () => {
        setLoading(true)
        fetch('https://ukies-api-search.eliteswitch.com/indexes/files/search', {
            method: 'POST',
            headers: {
                "authorization": 'Bearer ' + token,
                "content-type": 'application/json'
            },
            body: JSON.stringify({
                "q": search,
                "sort": ["id:desc"],
                "matchingStrategy": "all",
                "facets": ["*"],
                "filter": [],
                "offset": 0,
                "limit": 40000
            })
        })
            .then((response) => { return (response.json()) })
            .then((response) => {
                setAssets({ ...response })
                setLoading(false)
            })
            .catch((error) => {
                console.error('Error fetching assets:', error)
                setLoading(false)
            })
    }

    const uploadImage = async (e) => {
        setUploadingAsset(true)
        const reduce = require('image-blob-reduce')();
        let imageName = e.target.files[0].name
        let imageType = e.target.files[0].type
        let image = await reduce.toBlob(e.target.files[0], { max: 3840 })
        let imageSize = image.size

        // If image filesize is > 2mb, reduce by 200px till it's under 2mb
        if (imageSize > 1999999) {
            let newSize = 3600; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
            if (imageSize > 1999999) {
                newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                if (imageSize > 1999999) {
                    newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                    if (imageSize > 1999999) {
                        newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                        if (imageSize > 1999999) {
                            newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                            if (imageSize > 1999999) {
                                newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                                if (imageSize > 1999999) {
                                    newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                                    if (imageSize > 1999999) {
                                        newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                                        if (imageSize > 1999999) {
                                            newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                                            if (imageSize > 1999999) {
                                                newSize -= 200; image = await reduce.toBlob(e.target.files[0], { max: newSize }); imageSize = image.size
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Show warning message
            console.log('De afbeelding moest verkleind worden tot ' + newSize + 'px om onder de 2mb uploadlimiet te blijven.')
        }

        // Upload file naar Eliteswitch
        const payloadImage = new File([image], imageName, { type: imageType })
        let payload = new FormData()
        payload.append('file[]', payloadImage)

        fetch('https://ukies-api.eliteswitch.com/api/file', {
            method: 'POST',
            headers: {
                "authorization": 'Bearer ' + token,
            },
            body: payload
        })
            .then((response) => { return (response.json()) })
            .then((response) => {
                let tmpAssets = assets
                tmpAssets.hits.unshift(response.result.items[0])
                setAssets({ ...tmpAssets })
                setSelected(response.result.items[0])
                setUploadingAsset(false)
            })
            .catch((error) => {
                console.error('Error uploading image:', error)
                setUploadingAsset(false)
            })
    }

    const handleChooseAsset = (asset) => {
        if (onAssetSelect) {
            onAssetSelect(asset)
        }
        setOpen(false)
    }

    const handleRefresh = (e) => {
        e.preventDefault()
        getFiles()
    }

    const handleClose = () => {
        setOpen(false)
        setSelected({ id: 0 })
        setPreview('')
    }

    return (
        <>
            <Modal show={open} onHide={handleClose} size="xl">
                <Modal.Header closeButton style={{ backgroundColor: 'rgba(246, 247, 248, 0.5)' }}>
                    <Modal.Title>Ukie's afbeeldingenbibliotheek</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: '70vh', backgroundColor: 'rgba(246, 247, 248, 0.5)' }}>
                    {(loading || uploadingAsset) && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.70)',
                            zIndex: 1000,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Spinner animation="border" variant="light" />
                            <div style={{ color: '#fff', padding: '1rem' }}>
                                {loading ? 'Loading assets from Eliteswitch...' : 'Uploading in progress...'}
                            </div>
                        </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center">
                            <Form onSubmit={handleRefresh} className="d-flex align-items-center me-3">
                                <Form.Control
                                    type="text"
                                    placeholder="Zoek naar afbeeldingen"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    style={{ width: '300px' }}
                                    className="me-2"
                                />
                                <Button type="submit" variant="outline-primary">
                                    🔍
                                </Button>
                            </Form>
                            <div style={{ fontStyle: 'italic' }}>
                                {assetList.length} resultaten
                            </div>
                        </div>
                        <div>
                            <label htmlFor="asset-upload">
                                <Button as="span" variant="outline-primary" className="d-flex align-items-center">
                                    📤 Upload asset
                                </Button>
                            </label>
                            <input
                                accept="image/*"
                                hidden
                                id="asset-upload"
                                type="file"
                                onChange={(e) => { uploadImage(e) }}
                            />
                        </div>
                    </div>

                    <Row>
                        {assetList.map((asset) => {
                            return (
                                <Col key={asset.id} xs={12} sm={12} md={6} lg={4} xl={3} className="mb-3">
                                    <div style={{ position: 'relative' }}>
                                        <Card
                                            style={{
                                                cursor: 'pointer',
                                                height: '250px',
                                                border: selected.id === asset.id ? '2px solid #007bff' : '1px solid #dee2e6'
                                            }}
                                            onClick={() => setSelected(asset)}
                                            onDoubleClick={() => handleChooseAsset(asset)}
                                        >
                                            <div style={{
                                                height: '200px',
                                                overflow: 'hidden',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                backgroundColor: 'lightgray'
                                            }}>
                                                <img
                                                    src={asset.image_variations?.large}
                                                    alt={asset.name}
                                                    style={{
                                                        minWidth: '100%',
                                                        minHeight: '100%',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            </div>
                                            <Card.Body style={{ height: '50px', fontSize: '0.8rem', padding: '0.5rem' }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>{asset.name}</div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            onClick={() => setPreview(asset.image_variations?.large?.replace('large', 'w=3840'))}
                                            style={{
                                                position: 'absolute',
                                                top: '0.5rem',
                                                right: '0.5rem',
                                                padding: '0.25rem 0.5rem'
                                            }}
                                        >
                                            🔍
                                        </Button>
                                    </div>
                                </Col>
                            )
                        })}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Annuleren
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => handleChooseAsset(selected)}
                        disabled={!selected.id}
                    >
                        Selecteren
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Preview Modal */}
            <Modal show={preview.length > 0} onHide={() => setPreview('')} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img src={preview} alt="Preview" style={{ maxWidth: '100%', height: 'auto' }} />
                </Modal.Body>
            </Modal>
        </>
    )
} 